import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { langFromPath, setLangPreference } from '../utils/langPreference';

/** Keeps document lang + preference cookie in sync with the current route. */
const LangSync = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const lang = langFromPath(pathname);
    document.documentElement.lang = lang;
    setLangPreference(lang);
  }, [pathname]);

  return null;
};

export default LangSync;
